export default __webpack_public_path__ + "static/media/Obesity-2.1887baa1.jpg";